// extracted by mini-css-extract-plugin
module.exports = {"explanationContainer":"nRAVRU","knowMoreText":"WvTuHI","headline":"BVB5Y-","baseline":"UcP-RD"};